import React, { useEffect, useState } from 'react';
import { base_url } from '../Api/Api';
import { Loader } from '../Global/Loader';

import Header from '../Global/Header';
import ItemNotification from './ItemNotification';

const Notification = (props) => {

    const [state, setState] = useState({
        data: [],
        animStatus: true,
        loader: true
    })

    useEffect(() => {


        base_url.get(`notification_list`)
            .then(response => {
                console.log(response.data)
                setState({
                    ...state,
                    animStatus: false,
                    loader: false,
                    data: response.data
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })
            localStorage.setItem('unreadNotification',  false)
    }, [])

    return (
        <React.Fragment>
            <Loader
                active={state.loader} />
            <div className={`instructpg notif-list ${state.animStatus ? '' : 'active'}`}>
                <Header
                    innerPage={true}
                    title={'اعلانات'} />

                <div className="body-courses">

                    {state.data.map(info =>
                        <ItemNotification
                            data={info}
                            title={info.title}
                            decription={info.description}
                            date={info.jtime}
                            read={info.read} />
                    )}

                </div>

            </div>
        </React.Fragment>
    );
}

export default Notification;